<template>
    <div>

        <PageHeader side-class="flex-shrink-0">
            <div>{{ item.name }}</div>
            <template #side>
                <div class="d-flex gap-3">
                    <ButtonIcon icon="plus">{{ $t('addToGroup') }}</ButtonIcon>
                </div>
            </template>
        </PageHeader>

        <div class="mb-3">
            <div><strong>ID:</strong> {{ item.id }}</div>
        </div>

        <StatsWidgets />

        <TrafficChart />

        <SalesChart />

    </div>
</template>



<script>
    import StatsWidgets from './StatsWidgets.vue';
    import TrafficChart from './TrafficChart.vue';
    import SalesChart from './SalesChart.vue';

    export default {
        name: 'CategoryStats',
        components: {
            StatsWidgets,
            TrafficChart,
            SalesChart,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                requestSalesStats: this.$req('producerProductCategory/salesStats'),
                requestClicksStats: this.$req('producerProductCategory/clicksStats'),
                requestImpressionsStats: this.$req('producerProductCategory/impressionsStats'),
                requestTrafficChart: this.$req('producerProductCategory/trafficChart'),
                requestSalesChart: this.$req('producerProductCategory/salesChart'),
            };
        },
        computed: {
            timeRange() {
                return this.parentComponent.timeRange;
            },
        },
    };
</script>
